import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequest } from "@utils/http-util";
import { AxnAdminUser } from "@idw-types/data/axn-admin-user";

type GetAxnAdminUsersRequestResponse = {
    axnAdminUsers: Array<AxnAdminUser>;
};

export const getAxnAdminUsersRequest = async (): Promise<{ data: GetAxnAdminUsersRequestResponse, error: any }> => {
    const route = apiRoutes.axnadminCore.axnadmin.users;
    const { data, error } = await handleRequest(RequestTypes.GET, route);
    return { data, error };
};